import React, { FC, ReactElement } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { IconButton, Drawer, Box, Divider } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

// Components
import SideBarMenu from '../Sidebar/SideBarMenu';
import Footer from '../Footer/Footer';
import logo from '../../assets/svg/logo.svg';

// Constants
import { DRAWER_WIDTH } from '../../utils/constants';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: DRAWER_WIDTH,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      backgroundColor: '#23496B',
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: '#23496B',
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(7) + 3,
      },
    },
    toolbar: {
      backgroundColor: '#23496B',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 2),
      ...theme.mixins.toolbar,
    },
    hidden: {
      visibility: 'hidden',
    },
    logo: {
      width: `calc(${DRAWER_WIDTH}px - 70%)`,
    },
    appBarDivider: {
      backgroundColor: '#fff',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  })
);

interface Props {
  open: boolean;
  handleMenuClose: () => void;
}

const Navigation: FC<Props> = ({ open, handleMenuClose }): ReactElement => {
  const classes = useStyles();
  return (
    <>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {open && <img src={logo} alt="logo" className={classes.logo} />}
          <IconButton onClick={handleMenuClose}>
            <ChevronLeftIcon htmlColor="#fff" />
          </IconButton>
        </div>
        {open && <Divider className={classes.appBarDivider} />}
        <SideBarMenu drawerOpened={open} />
        {open && <Footer />}
      </Drawer>
    </>
  );
};

export default Navigation;
